import React from 'react'
import { Badge, IdCardIcon, VialCircleCheckIcon, VialIcon } from '@quickmd-llc/design-system'
import { DRUG_SCREEN_STATUS, ID_VERIFICATION_STATUSES } from 'utils/constants'
import {
  type PatientDrugScreenStatusStaffApiOutContract,
  type PatientIdentityVerificationStaffApiOutContract,
} from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'

type DrugScreen = PatientDrugScreenStatusStaffApiOutContract
type IDVerification = PatientIdentityVerificationStaffApiOutContract
type IDVerificationBadgeType = {
  verification?: IDVerification
  onClick?: () => void
  hideSuccess?: boolean
}
type DrugScreenBadgeType = {
  drugScreen?: DrugScreen
  onClick?: () => void
  hideSuccess?: boolean
}
export function renderDrugScreenBadge({ drugScreen, onClick, hideSuccess }: DrugScreenBadgeType) {
  if (!drugScreen) {
    return null
  }
  switch (drugScreen.Status) {
    case DRUG_SCREEN_STATUS.verified:
      if (hideSuccess) return null
      return (
        <Badge
          size='s'
          variant='success'
          className={onClick ? 'cursor-pointer' : ''}
          icon={<VialCircleCheckIcon iconSize='xs' />}
          onClick={onClick}>
          Drug screen verified
        </Badge>
      )
    case DRUG_SCREEN_STATUS.review:
      return (
        <Badge
          size='s'
          variant='idle'
          className={onClick ? 'cursor-pointer' : ''}
          icon={<VialIcon iconSize='xs' />}
          onClick={onClick}>
          Drug screen in review
        </Badge>
      )
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    case DRUG_SCREEN_STATUS.rejected:
      return (
        <Badge size='s' variant='error' icon={<VialIcon iconSize='xs' />}>
          Drug screen rejected
        </Badge>
      )
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    case DRUG_SCREEN_STATUS.pending:
      return (
        <Badge
          size='s'
          className={onClick ? 'cursor-pointer' : ''}
          variant='idle'
          icon={<VialIcon iconSize='xs' />}
          onClick={onClick}>
          Drug screen pending
        </Badge>
      )
    case DRUG_SCREEN_STATUS.expired:
      return (
        <Badge
          size='s'
          variant='error'
          className={onClick ? 'cursor-pointer' : ''}
          icon={<VialIcon iconSize='xs' />}
          onClick={onClick}>
          Drug screen expired
        </Badge>
      )
    case DRUG_SCREEN_STATUS.exempt:
      if (hideSuccess) return null
      return (
        <Badge size='s' variant='success' icon={<VialCircleCheckIcon iconSize='xs' />}>
          Drug screen exempt
        </Badge>
      )
    case DRUG_SCREEN_STATUS.duesoon:
      return (
        <Badge size='s' variant='warning' icon={<VialIcon iconSize='xs' />}>
          Drug screen due soon
        </Badge>
      )
    case DRUG_SCREEN_STATUS.due:
      return (
        <Badge size='s' variant='error' icon={<VialIcon iconSize='xs' />}>
          Drug screen not on file
        </Badge>
      )
    default:
      return null
  }
}

export function renderIDVerificationBadge({ verification, onClick, hideSuccess }: IDVerificationBadgeType) {
  switch (verification?.Status) {
    case ID_VERIFICATION_STATUSES.failed:
      return (
        <Badge
          variant='error'
          size='s'
          className={onClick ? 'cursor-pointer' : ''}
          icon={<IdCardIcon iconSize='xs' />}
          onClick={onClick}>
          ID failed
        </Badge>
      )
    case ID_VERIFICATION_STATUSES.legacyverified:
      if (hideSuccess) return null
      return (
        <Badge size='s' variant='success' icon={<IdCardIcon iconSize='xs' />}>
          ID legacy verified
        </Badge>
      )
    case ID_VERIFICATION_STATUSES.manuallyverified:
      if (hideSuccess) return null
      return (
        <Badge
          size='s'
          variant='success'
          className={onClick ? 'cursor-pointer' : ''}
          icon={<IdCardIcon iconSize='xs' />}
          onClick={onClick}>
          ID manually verified
        </Badge>
      )
    case ID_VERIFICATION_STATUSES.verified:
      if (hideSuccess) return null
      return (
        <Badge
          size='s'
          variant='success'
          className={onClick ? 'cursor-pointer' : ''}
          icon={<IdCardIcon iconSize='xs' />}
          onClick={onClick}>
          ID verified
        </Badge>
      )
    case ID_VERIFICATION_STATUSES.unverified:
      return (
        <Badge size='s' variant='idle' icon={<IdCardIcon iconSize='xs' />}>
          ID not verified
        </Badge>
      )
    case ID_VERIFICATION_STATUSES.warning:
      return (
        <Badge
          size='s'
          variant='warning'
          className={onClick ? 'cursor-pointer' : ''}
          icon={<IdCardIcon iconSize='xs' />}
          onClick={onClick}>
          ID warning
        </Badge>
      )
    case ID_VERIFICATION_STATUSES.requested:
      return (
        <Badge size='s' variant='idle' icon={<IdCardIcon iconSize='xs' />}>
          ID requested
        </Badge>
      )
    case ID_VERIFICATION_STATUSES.processing:
      return (
        <Badge
          size='s'
          variant='active'
          className={onClick ? 'cursor-pointer' : ''}
          icon={<IdCardIcon iconSize='xs' />}
          onClick={onClick}>
          ID review
        </Badge>
      )
    default:
      return null
  }
}
export const DrugScreenBadge: React.FC<DrugScreenBadgeType> = ({ drugScreen, onClick, hideSuccess }) => (
  // @ts-expect-error TS2379 -- MIGRATION: not approved, fix when encountered
  <>{renderDrugScreenBadge({ drugScreen, onClick, hideSuccess })}</>
)
export const IDVerificationBadge: React.FC<IDVerificationBadgeType> = ({ verification, onClick, hideSuccess }) => (
  // @ts-expect-error TS2379 -- MIGRATION: not approved, fix when encountered
  <>{renderIDVerificationBadge({ verification, onClick, hideSuccess })}</>
)
